import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/login";
import Dashboard from "./pages/dashboard/dashboard";
import AppLayout from "./components/AppLayout";
import PrivateRoute from "./components/RouteHelpers/PrivateRoute";
import PublicRoute from "./components/RouteHelpers/PublicRoute";

import ExamGroups from "./pages/exam-groups";
import ExamGroup from "./pages/exam-group";
import Exam from "./pages/exam";
import Papers from "./pages/papers";
import Paper from "./pages/paper";
import Subjects from "./pages/subjects";
import Feedbacks from "./pages/feedbacks";
import Transactions from "./pages/transactions";
import Topics from "./pages/topics";
import Feedback from "./pages/feedback";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import ManageInstitutions from "./pages/manage-institutions";
import QuizathonDetails from "./pages/QuizathonDetails";
import QuizathonList from "./pages/quizathon";
import UserProfile from "./pages/QuizathonDetails/UserProfile";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-request"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route element={<AppLayout />}>
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam-groups"
            element={
              <PrivateRoute>
                <ExamGroups />
              </PrivateRoute>
            }
          />
           <Route
            path="/manage-institutions"
            element={
              <PrivateRoute>
                <ManageInstitutions />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam-groups/:id"
            element={
              <PrivateRoute>
                <ExamGroup />
              </PrivateRoute>
            }
          />
          <Route
            path="/exams/:id"
            element={
              <PrivateRoute>
                <Exam />
              </PrivateRoute>
            }
          />
           <Route
            path="/quizathon-list"
            element={
              <PrivateRoute>
                <QuizathonList />
              </PrivateRoute>
            }
          />
            <Route
            path="/quizathon-participant/:quizathonId/:studentId"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
           <Route
            path="/quizathon-list/:id"
            element={
              <PrivateRoute>
                <QuizathonDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/subjects"
            element={
              <PrivateRoute>
                <Subjects />
              </PrivateRoute>
            }
          />
          <Route
            path="/papers"
            element={
              <PrivateRoute>
                <Papers />
              </PrivateRoute>
            }
          />
          <Route
            path="/papers/:id"
            element={
              <PrivateRoute>
                <Paper />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks"
            element={
              <PrivateRoute>
                <Feedbacks />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <PrivateRoute>
                <Feedback />
              </PrivateRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <PrivateRoute>
                <Transactions />
              </PrivateRoute>
            }
          />
          <Route
            path="/topics/:subjectName"
            element={
              <PrivateRoute>
                <Topics />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
